import { render } from "./ChangePasswordMaintenance.vue?vue&type=template&id=c990f0dc&scoped=true"
import script from "./ChangePasswordMaintenance.vue?vue&type=script&lang=js"
export * from "./ChangePasswordMaintenance.vue?vue&type=script&lang=js"

import "./ChangePasswordMaintenance.vue?vue&type=style&index=0&id=c990f0dc&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c990f0dc"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QCard,QCardSection,QIcon,QCardActions});
